import * as React from "react";
import {
  Box,
  Divider,
  Drawer,
  Icon,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";

export interface SectionNavItem {
  id: number;
  section: string;
  href: string;
  icon: React.ReactNode;
  active?: boolean;
}

export interface SectionNavProps {
  items: SectionNavItem[];
  drawerWidth: number;
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

export function SectionNav({ items, drawerWidth }: SectionNavProps) {
  return (
    <Drawer
      variant="permanent"
      anchor="right"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          borderLeft: "0.5px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
        },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: "auto", backgroundColor: "rgba(0,0,0,0.03)", flex: 1 }}>
        <List>
          {items.map((nav, index) => (
            <a
              key={index}
              href={nav.href}
              style={{ textDecoration: "none" }}
            >
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    borderLeft: "2px solid transparent",
                    borderColor: nav.active ? "primary.main" : "transparent",
                    borderRadius: 0,
                    pl: nav.active ? 1.75 : 2,
                    backgroundColor: nav.active ? "rgba(0,0,0,0.12)" : "transparent",
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.02)" },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Icon
                      sx={{
                        fontSize: 18,
                        color: nav.active ? "primary.main" : "text.disabled",
                      }}
                    >
                      {nav.icon}
                    </Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={nav.section}
                    primaryTypographyProps={{
                      variant: "body2",
                      color: "text.secondary",
                      fontWeight: "unset",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </a>
          ))}
        </List>
        <Divider />
      </Box>
    </Drawer>
  );
}
